<template>
  <div class="text-sm">
    <p class="mt-6">
      <b>2024.11.05</b> - dwarf/elf/faerie and poppets summons have been limited to 2~5,
      scaling with ability level
    </p>
  </div>
</template>
